import { ILineType } from "./lineInfo.types";

export class LineType implements ILineType {
  readonly lineTypeCode: string;
  readonly lineTypeName: string;
  readonly displayOrder: number;

  constructor(data: ILineType) {
    this.lineTypeCode = data.lineTypeCode;
    this.lineTypeName = data.lineTypeName;
    this.displayOrder = data.displayOrder;
  }
}
